'use client'

import Script from 'next/script'
import { usePathname } from 'next/navigation'

const SALESIQ_DISABLED_PATH_PREFIXES = ['/checkout', '/pay', '/explanation', '/account']

function isPathDisabled(pathname: string, disabledPrefixes: string[]) {
  return disabledPrefixes.some(prefix =>
    pathname === prefix || pathname.startsWith(`${prefix}/`)
  )
}

export const ZohoSalesIQ = () => {
  const pathname = usePathname()
  const currentPath = pathname ?? '/'
  const widgetToken = process.env.NEXT_PUBLIC_ZOHO_SALESIQ_WIDGET_TOKEN?.trim()

  const shouldRenderScript =
    Boolean(widgetToken) &&
    !isPathDisabled(currentPath, SALESIQ_DISABLED_PATH_PREFIXES)

  if (!shouldRenderScript) {
    return null
  }

  return (
    <>
      <Script
        id="zoho-salesiq-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html:
            'window.$zoho=window.$zoho || {};$zoho.salesiq=$zoho.salesiq||{ready:function(){}}',
        }}
      />
      <Script
        id="zsiqscript"
        src={`https://salesiq.zohopublic.com/widget?wc=${widgetToken}`}
        strategy="afterInteractive"
      />
    </>
  )
}